<template>
    <footer class="sticky-footer bg-white">
        <div class="container my-auto">
            <div class="copyright text-center my-auto">
                <span v-if="system" class="float-left">{{$t(system.copyright_text)}}</span>
                <div class="float-right font-italic">{{$t('Build Version')}}: {{version}}</div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterPage',
    props:['system'],
    data() {
        return {
            version: process.env.VUE_APP_SOURCE_VERSION,
        }
    }
}
</script>

<style>

</style>